module.exports = __webpack_public_path__ + "static/img/8.f294005.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/8.png
// module id = zvZM
// module chunks = 0